export default {
  name: "Application Documents",
  pageInfo: {
    text: "Below, you will find a summary of the documents that you have uploaded to this application throughout the form.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "application_documents",
          validate: [],
          checkDocuments: [
            "supervisedRecruitmentAttached",
            "playerContractAttached",
            "offSeasonAttached",
            "unionLetterAttached",
            "professionalAssociationAttached",
            "teamRevenueAttached",
            "playerStatisticsAttached",
          ],
          isDeletable: true,
          requiredDocuments: [
            "supervisedRecruitmentAttached",
            "playerContractAttached",
            "offSeasonAttached",
            "playerStatisticsAttached",
          ],
          //Temporarily removing Add Document button

          // modal: {
          //   machine_name: "app_documents",
          //   name: "Application Documents",
          //   widget: "file_upload",
          //   label:
          //     "<span>Read and agree to all the application terms, assurances, and obligations contained in <u>Appendix A</u> and attach a signed and dated copy with this application.</span>",
          //   fileTypes: [".pdf", ".png", ".jpg"],
          // },
        },
      ],
    },
  ],
};
